<template>
  <div class="home font_Montserrat v3_color_black_knight" :class="isRecruiter ? 'home-page' : ''">
    <div class="shadow-none py-2 header-tabs">
        <div class="profile-tab">
            <h2 class="mb-0 font_size_1250rem font_weight_bold my-profile clickable" :class="isUser ? 'v3_color_teal' : ''">
                <span @click="showProfile">My Profile</span>
            </h2>
            <h2 v-if="isRecruiter" class="mb-0 font_size_1250rem font_weight_bold purchase-history clickable">
                <span @click="getPurchaseHistory">Purchase History</span>
            </h2>
        </div>
      <!-- <b-row align-v="center">
        <b-col cols="12" sm="2" class="max-width-50">
            <div class="h-100 d-flex align-items-center justify-content-center clickable border-teal-right">
              <h2 class="mb-0 font_size_1250rem font_weight_bold padding-tb-10">
                  <span @click="showProfile">My Profile</span>
              </h2>
            </div>
        </b-col>
        <b-col cols="12" sm="10" class="pl-0 max-width-50">
            <div class="h-100 d-flex align-items-center justify-content-center clickable">
              <h2 class="mb-0 font_size_1250rem font_weight_bold">
                  <span @click="getPurchaseHistory">Purchase History</span>
              </h2>
            </div>
        </b-col>
      </b-row>  -->
    </div>  
    <template v-if="showProfileContent">
      <b-card no-body class="v3_box_teal shadow-none mt-3">
        <component
            :is="userRole"
            :save-loading="saveLoading"
            @profileFormCancel="onProfileFormCancel"
            @profileFormSubmit="onProfileFormSubmit"
        />
        <div class="grey-box" v-if="isUser || isRecruiter" >
          <div class="border_1 border_grey p-3">
            <b-row>
              <b-col>
              <new-password-form :user-id="parseInt(user.id)" />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card>
    </template>
    <template v-if="showPurchaseContent">
      <b-card no-body class="v3_box_teal shadow-none mt-4">
        <user-purchase-history />
      </b-card>
    </template>
  </div>
</template>

<!-- --------------------------------------------------- -->

<script>
import UserProfileAdminForm from '@/components/users/profile/forms/UserProfileAdminForm';
import UserProfileMssUserForm from '@/components/users/profile/forms/UserProfileMssUserForm';
import {handleServerErrorWithValidation} from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';
import GetMemberTypeMappingOptionsMixin from '@/mixins/GetMemberTypeMappingOptionsMixin';
import GetMembershipTypeOptionsMixin from '@/mixins/GetMembershipTypeOptionsMixin';
import UserProfileRecruiterForm from "@/components/users/profile/forms/UserProfileRecruiterForm";
import UserPurchaseHistory from "@/components/users/history/UserPurchaseHistory";
import NewPasswordForm from '@/components/users/NewPasswordForm';

export default {
  name: 'UserProfile',
  mixins: [GetMembershipTypeOptionsMixin, GetMemberTypeMappingOptionsMixin],
  components: {
    UserProfileAdminForm,
    UserProfileMssUserForm,
    UserProfileRecruiterForm,
    UserPurchaseHistory,
    NewPasswordForm
  },
  data: function () {
    return {
      saveLoading: false,
      showProfileContent:true,
      showPurchaseContent:false
    };
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    userRole: function () {
      if (this.$store.getters.userIsMSSRecruiter) {
        return UserProfileRecruiterForm.name;
      }
      if (this.$store.getters.userIsAdmin) {
        return UserProfileAdminForm.name;
      }
      return UserProfileMssUserForm.name;
    },
    isUser: function() {
     return this.$store.getters.userIsMSSUser ? true : false;
    },
    isRecruiter: function() {
      return this.$store.getters.userIsMSSRecruiter ? true : false;
    }
  },
  methods: {
    onProfileFormCancel: function () {
      this.$router.back();
    },
    onProfileFormSubmit: async function (userData) {
      try {
        this.saveLoading = true;
        await Api.updateUserProfile(userData, true);
        this.$toasted.success('Profile is updated', {
          duration: 3000,
        });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.saveLoading = false;
      }
    },
    getPurchaseHistory: function() {
      this.showPurchaseContent = true;
      this.showProfileContent = false;
    },
    showProfile: function() {
      this.showPurchaseContent = false;
      this.showProfileContent = true;
    }
  },
};
</script>

<!-- --------------------------------------------------- -->

<style scoped>
@media (max-width: 768px) {
  .home-page {
    margin: 0 1rem;
  }
  .max-width-50{
    max-width:50%;
  }
  .profile-tab h2{
    padding: 10px !important;
  }
  .profile-tab{
   justify-content: center !important;
  }
  .grey-box {
    padding: 1rem !important;
  } 
}
.home-page {
  margin-top: 0px !important;
}
.border_grey{
  border-color: #9BA1A5 !important;
}
.profile-tab{
  display: flex;
  align-items: center;
}
.profile-tab .my-profile{
  padding-left:2px;
}
.profile-tab h2{
  padding: 20px;
  border-right:2px solid #016178;
}
.profile-tab h2:last-child{
  border-right:unset;
}
</style>

<style lang="scss">
// HACK: valid style border color is overriding invalid style - not sure why both
// classes are applying to invalid inputs???
@import '../../../../sass/variables_mixins';

.was-validated .form-control:invalid,
.form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #dc3545 !important;
}

.zip-input {
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
}

.user-profile {
  .card-body,
  .card-header {
    padding: 10px 15px;
  }

  padding-bottom: 5em;

  .invalid-feedback {
    display: block;
  }
}
</style>
